import {IStore} from "modules/store";
import {createSelector} from "@reduxjs/toolkit";
import {NullOrEmpty} from "modules/types";
import {memoize} from "lodash";

const getState = ({JSON}: IStore) => JSON;

export const getPlayers = createSelector(getState, (state) => state.players);

export const getPlayerById = createSelector(getPlayers, (players) => {
	return memoize((id: NullOrEmpty<number> = 0) => {
		return players.find((player) => player.id === id);
	});
});

export const getSquads = createSelector(getState, (state) => state.squads);

export const getSquadById = createSelector(getSquads, (squads) => {
	return memoize((id: NullOrEmpty<number> = 0) => {
		return squads.find((squad) => squad.id === id);
	});
});
